import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Footer from "../pages/Footer"; // ✅ Import Footer

import { useSelector } from "react-redux";

const MainLayout = ({ children, title }) => {
  const isDarkMode = false; // Replace with state/context for dark mode
  const navigate = useNavigate();
  const token = useSelector((state) => state.userTokenReducer?.token);
  
  return (
    <div
      className={`w-full min-h-screen flex flex-col items-center justify-between ${isDarkMode ? "bg-gray-900 text-white" : "bg-gray-100 text-black"
        }`}
    >
      <div className="w-full max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-5xl h-screen bg-white shadow-lg flex flex-col overflow-hidden">
        
        <main className="flex-1 p-0 overflow-y-auto">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

MainLayout.defaultProps = {
  title: "Welcome",
};

export default MainLayout;
